<template>
  <div>
    <div class="shippingHistoryTable">
      <v-expansion-panels
        accordion
        multiple
        v-model="openPanelIndex"
        class="rounded-lg"
      >
        <v-expansion-panel class="parent_expansion">
          <!-- 共通ヘッダー -->
          <div
            class="
              orderHeader
              historyHeader
              yCenter
              bottomBorder
              font-weight-bold
            "
            v-bind:class="{
              headerColor: false
            }"
          >
            <div class="action">
              <v-checkbox v-if="false" class="ml-3"> </v-checkbox>
            </div>
            <div class="yCenter">
              <div
                v-for="(header, index) in headers"
                :key="index"
                v-bind:style="{ width: header.width }"
              >
                {{ $t(header.text) }}
              </div>
            </div>
          </div>
        </v-expansion-panel>

        <v-data-table
          :items="propsItems"
          item-key="panelIndex"
          group-by="panelIndex"
          :hide-default-header="false"
          hide-default-footer
          class="rounded-lg elevation-1 width100"
          :items-per-page="-1"
          :no-data-text="$t('common.common_no-history')"
        >
          <template v-slot:group="props">
            <v-expansion-panel>
              <div class="yCenter orderHeader historySubHeader bottomBorder">
                <!-- 処理単位グループ情報 -->
                <div class="action originalCenter">
                  <DisplaySwitchButton
                    :open="
                      !!openPanelIndex.find(
                        (ele) => ele === props.items[0].panelIndex
                      )
                    "
                    class="ma-0"
                    @click.native="panelClick(props.items[0].panelIndex)"
                  />
                </div>
                <div class="yCenter">
                  <div
                    v-bind:style="{ width: getWidth('notificationDate') }"
                    class="colStyle"
                  >
                    {{ props.items[0].date }}
                  </div>
                  <div
                    v-bind:style="{ width: getWidth('createdBy') }"
                    class="colStyle"
                  >
                    {{
                      props.items[0].user.lastName +
                      props.items[0].user.firstName
                    }}
                  </div>
                </div>
              </div>
              <v-expansion-panel-content class="panelContentStyle">
                <div>
                  <ShippingHistoryTable
                    :headers="subHeaders"
                    :props-items="props.items[0].products"
                    :rec-items="recItems"
                    :tableKey="itemKey"
                  >
                  </ShippingHistoryTable>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-data-table>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import DisplaySwitchButton from '@/components/items/Buttons/DisplaySwitchButton'
import ProductTable from '@/components/items/Tables/ProductTable'
import ShippingHistoryTable from '@/components/items/Tables/ShippingHistoryTable'
export default {
  name: 'ShipDeliveryHistoryTable',
  components: {
    DisplaySwitchButton,
    ProductTable,
    ShippingHistoryTable
  },
  props: {
    headers: [],
    subHeaders: [],
    propsItems: {
      type: Array,
      require: true,
      default: () => []
    },
    recItems: {
      type: Object,
      require: true,
      default: () => []
    },
    itemKey: String
  },
  data: () => ({
    paymentIdName: '',
    openPanelIndex: []
  }),
  created() {},
  methods: {
    panelClick(index) {
      this.openPanelIndex.find((ele) => ele === index)
        ? (this.openPanelIndex = this.openPanelIndex.filter(
            (ele) => ele !== index
          ))
        : this.openPanelIndex.push(index)
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    }
  },
  computed: {
    tableHeaders() {
      if (!Array.isArray(this.headers)) {
        return []
      }
      const headersTmp = this.headers.map((header) => {
        if (!this.isOperation) {
          if (header.value === 'operationId') {
            header.text = ''
            header.value = 'noDisplay'
          }
        }
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.shippingHistoryTable {
  ::v-deep .v-data-table th {
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
  .parent_expansion {
    color: rgba(0, 0, 0, 0.6);
  }
}
.normalNumberInput {
  width: 180px;
}
.shippingHistoryTable {
  font-size: 12px;

  .icon {
    order: 0;
  }
  .header {
    order: 1;
  }
  .width100 {
    width: 100%;
  }

  // .productTable {
  //   ::v-deep .v-data-table th {
  //     background-color: #fafafb;
  //     border: solid 1px #d8d8d8;
  //     border-collapse: collapse;
  //     text-align: center !important;
  //   }
  //   ::v-deep .v-data-table td {
  //     // background-color: #f6f6f6;
  //     border: solid 1px #d8d8d8;
  //     border-collapse: collapse;
  //   }
  // }
  ::v-deep .v-expansion-panel {
    margin: 0;
  }
  .panelContentStyle::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
  .panelHeaderStyle {
    height: 41px;
    padding: 0px 20px;
  }
  .panelContentHeaderStyle {
    height: 61px;
    padding: 0px 20px;
    background-color: rgba(151, 198, 234, 0.1);
  }
  .allButtonArea {
    font-size: 14px;
    margin: 15px;
  }
  .bottomBorder {
    border-bottom: 1px solid #d8d8d8;
  }
  .historyHeader {
    height: 41px;
    background-color: rgba(151, 198, 234, 0.1) !important;
  }
  .historySubHeader {
    min-height: 61px;
  }

  .selectColor {
    background-color: rgba(151, 198, 234, 0.1);
  }
  .rowColorCancel {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .rowColorBeforeComplete {
    background-color: rgba(151, 198, 234, 0.1);
  }

  .orderHeader {
    width: 100%;
    padding-left: 10px;

    .btnStyle {
      max-width: 105px;
      padding: 0px !important;
    }

    .action {
      min-width: 80px;
    }
    .orderDate {
      width: 100px;
      background-color: rgba(0, 0, 0, 0);
    }
    .supplierId {
      width: 110px;
      background-color: rgba(0, 0, 0, 0);
    }
    .userId {
      width: 70px;
      background-color: rgba(0, 0, 0, 0);
    }
    .amount {
      width: 90px;
      background-color: rgba(0, 0, 0, 0);
    }
    .status {
      background-color: rgba(0, 0, 0, 0);
    }
  }

  .orderInfo {
    border-bottom: 1px #d8d8d8 solid;
    // padding: 15px 40px;
  }
}

.headerColor {
  background-color: rgba(151, 198, 234, 0.1);
}
.footerFontStyle {
  font-size: 14px;
}
</style>
